module.exports = __webpack_public_path__ + "media/images/icons/sort_asc_disabled-d6b20552066546b572d4443cfcced8ec.png";